import { ReactComponent as Spotify } from 'assets/icons/icon-spotify.svg';

export default Spotify;
